import {Component, Inject, LOCALE_ID, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Info} from '../model/info';
import {AppService} from '../app.service';
import {Subscription} from 'rxjs';
import {SPBanner} from '../model/SPBanner';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.css'],
    standalone: false
})
export class BannerComponent implements OnInit, OnDestroy {

  show = true;
  lng: string;
  uk: boolean = null;

  banner: SPBanner;
  safeHtmlContent: SafeHtml;

  infoDataSubscription: Subscription;

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private $http: HttpClient,
    private appService: AppService,
    private sanitizer: DomSanitizer
  ) { }

    ngOnInit(): void
    {
        this.infoDataSubscription = this.appService.infoData
          .subscribe((info: Info) => {
            this.uk = (info.oj === 'UK');
          });

        this.$http.get('/ais/rest/portal/student/banner')
          .subscribe((data: SPBanner) => {
            this.banner = data;
            this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.banner.script);
        });
    }

    ngOnDestroy(): void {
      this.infoDataSubscription.unsubscribe();
    }

    viacNezobrazovat(): void
    {
      this.show = false;

      this.$http
        .post('/ais/rest/portal/portal/vypnut-instrukcie', null, {})
        .subscribe();
    }
}
